import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { catchError, map, Observable, throwError } from "rxjs";
import { AppConfig, APP_CONFIG_TOKEN } from "libs/config/app.lib.config";
import { AnamnesisModel, ReleaseData } from "../models/anamnese.model";
import { FunctionALQuestionnaireModel } from "libs/questionaire/src/lib/functional/models";
import { MichiganSplintQuestionnaireModel } from "libs/questionaire/src/lib/michigan-splint/models/questionnaire-michigan-splint.model";

@Injectable({
	providedIn: 'root'
})
export class AnamnesisService{
	private httpClient = inject(HttpClient);
	private config = inject<AppConfig>(APP_CONFIG_TOKEN);

	getReleaseData(treatmentId: string) : Observable<ReleaseData>{
		const params = {
			treatment: treatmentId
		}
		return this.httpClient.get<AnamnesisModel[]>(`${this.config.apiUrl}/anamneses`, {
			params,
			withCredentials: true
		}).pipe(
			map(res => {
				return res.at(0)?.releaseData;
			}),
			catchError(error => {
				return throwError(() => new Error(error.message || 'An unknown error occurred'));
			}));
	}

	getFunctionALQuestionnaireData(treatmentId: string) : Observable<FunctionALQuestionnaireModel>{
		const params = {
			treatment: treatmentId
		}
		return this.httpClient.get<AnamnesisModel[]>(`${this.config.apiUrl}/anamneses`, {
			params,
			withCredentials: true
		}).pipe(
			map(res => {
				const questionnaireData = res.at(0)?.questionnaireData?.functionAL;
				if (!questionnaireData) {
					throw new Error('Questionnaire data is null or undefined');
				}
				return questionnaireData;
			}),
			catchError(error => {
				return throwError(() => new Error(error.message || 'An unknown error occurred'));
			})
		);
	}

	getMichiganSplintQuestionnaireData(treatmentId: string) : Observable<MichiganSplintQuestionnaireModel>{
		const params = {
			treatment: treatmentId
		}
		return this.httpClient.get<AnamnesisModel[]>(`${this.config.apiUrl}/anamneses`, {
			params,
			withCredentials: true
		}).pipe(
			map(res => {
				const questionnaireData = res.at(0)?.questionnaireData?.michiganSplint;
				if (!questionnaireData) {
					throw new Error('Questionnaire data is null or undefined');
				}
				return questionnaireData;
			}),
			catchError(error => {
				return throwError(() => new Error(error.message || 'An unknown error occurred'));
			})
		);
	}

	updateReleaseData(treatmentId: string, releaseData: ReleaseData) : Observable<AnamnesisModel>{
		const params = {
			treatment: treatmentId
		}
		const body = {
			releaseData: releaseData
		}
		return this.httpClient.patch<AnamnesisModel>(`${this.config.apiUrl}/anamneses`, body, {
			params,
			withCredentials: true
		})
	}

}
